import { useRef } from "react";
import { Tooltip } from "react-tooltip";
import { ModalHandle } from "@src/components/Modal/Modal";
import { PipelineHealthIndicator } from "./PipelineHealthIndicator";
import { PipelineHealthPopup } from "./PipelineHealthPopup";
import { usePipelineHealthSummary } from "./usePipelineHealthSummary";

interface PipelineHealthWidgetProps {
	isExpanded: boolean;
	isHidden: boolean;
}

export const PipelineHealthWidget = ({ isExpanded, isHidden }: PipelineHealthWidgetProps) => {
	const { summary, loading, error, refreshing, refetch } = usePipelineHealthSummary();
	const modalRef = useRef<ModalHandle>(null);

	if (isHidden) {
		return null;
	}

	return (
		<>
			<PipelineHealthIndicator
				alertCounts={summary?.alertCounts ?? null}
				loading={loading}
				isExpanded={isExpanded}
				onClick={() => {
					refetch();
					modalRef.current?.openModal();
				}}
			/>
			<Tooltip id="sidebar-tooltip" place="right" />
			<PipelineHealthPopup ref={modalRef} summary={summary} loading={loading} error={error} refreshing={refreshing} onRefresh={refetch} />
		</>
	);
};
